import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default class UsuarioService extends CommonService {
    constructor(http) {
        super(http);
    }

    getAll(page, qntd, range) {

        let url = `usuarios?_page=${page}&_pagesize=${qntd}&_range=${range}`;
        return this._resource.get(url).then(success => {
            return success.body;
        },
            failed => {
                return failed;
            })
    }

    getUsuarioByToken(token) {
        let url = `usuarios?token=${token}`;
        return this._resource.get(url).then(success => {
            return success;
        }, failed => {
            return failed;
        })
    }

    cadastrarUsuario(usuario) {
        let url = `usuarios`;
        let body = JSON.stringify(usuario);
        return this._resource.post(url, body).then(success => {
            return success.body;
        }, failed => {
            return failed;
        })
    }

    cadastrar(usuario, idConta, reenvio) {
        let url = `contas/colaborador/${idConta}`;
        let body = JSON.stringify(usuario);
        

        if (!reenvio){
            return this._resource.post(url, body).then(success => {
                
                success['infoMessage'] = { msg: 'Colaborador cadastrado com sucesso.', ok: true }
                
                return success;
            }, failed => {
                failed['infoMessage'] = { msg: 'Não conseguimos cadastrar o colaborador.', ok: false }
                return failed;
            })
        }else{
            return this._resource.post(url, body).then(success => {
                
                success['infoMessage'] = { msg: 'Email enviado com sucesso.', ok: true }
                
                return success;
            }, failed => {
                failed['infoMessage'] = { msg: 'Não conseguimos reenviar o Email.', ok: false }
                return failed;
            })
        }
    }
    getUsuarioId(idUsuario) {
        let url = `usuarios/${idUsuario}`;
        return this._resource.get(url).then(success => {
            return success;
        }, failed => {
            return failed;
        })
    }
    removerDaConta(idConta, idColab, idEmp) {
        let url = `contas/colaborador/${idConta}`;
        let obj = {};
        obj['colaborador'] = idColab;
        obj['empresa'] = idEmp;
        let body = JSON.stringify(obj);
        return this._resource.delete(url, {
            body: { colaborador: idColab, empresa: idEmp },
        }).then(success => {
            success['infoMessage'] = { msg: 'Colaborador desativado.', ok: true }
            return success;
        }, failed => {

            failed['infoMessage'] = { msg: 'Não conseguimos desativar o Colaborador.', ok: false }
            return failed;
        })
    }
    
    relatorio(page, qntdNfe, id_empresa, range, urlFiltros, tipo, idUsuario) {
        // /usuarios/relatorio/5c9e6ffcb073f519943342f1
        let url = `usuarios/relatorio/${idUsuario}?_page=${page}&_pagesize=${qntdNfe}&_range=${range}`;
        return this._resource.get(url).then(success => {
            return success.body;
        }, failed => {
            return failed;
        })
    }

    editar(usuario, idUsuario) {

        let url = `usuarios/${idUsuario}`;

        // let body = JSON.stringify(usuario);
        return this._resource.patch(url, usuario).then(success => {

            success['infoMessage'] = { msg: 'As informações foram editadas.', ok: true }
            return success;
        }, failed => {

            failed['infoMessage'] = { msg: 'Não conseguimos editar as informações.', ok: false }
            return failed;
        })
    }

}


// WEBPACK FOOTER //
// ./src/domain/conta/usuario/UsuarioService.js